import React, { useState, useEffect } from "react";

// Luxury welcome preloader (~4.5s). Displays the VIIMII STUDIO wordmark with a
// slow-motion reveal. When a real logo is uploaded via admin, swap the wordmark
// block below for an <img>.
export default function Preloader({ onDone }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 4000);
    const t2 = setTimeout(() => onDone && onDone(), 4800);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onDone]);

  return (
    <div className={`preloader ${leaving ? "preloader-out" : ""}`}>
      <div className="pl-glow" />
      <div className="pl-inner">
        <div className="pl-ring" />
        <div className="pl-mark">
          <span className="pl-sub pl-sub-top">Welcome to</span>
          <h1 className="pl-title font-display">
            <span className="pl-letter">V</span>
            <span className="pl-letter">I</span>
            <span className="pl-letter">I</span>
            <span className="pl-letter">M</span>
            <span className="pl-letter">I</span>
            <span className="pl-letter">I</span>
          </h1>
          <span className="pl-sub pl-sub-bot">Nail Studio &amp; Hair Spa</span>
          <div className="pl-bar"><span /></div>
        </div>
      </div>
    </div>
  );
}
